import DesktopManinNavigationState from "@dana/Store/Data/DesktopMainNavigation/DesktopManinNavigationState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: DesktopManinNavigationState = {
    isOpen: false,
    navDrawerIsOpen: undefined,
    flyoutDrawerIsOpen: undefined,
    
};

const  desktopManinNavigationReducer = createTypedReducerWithImmer(initialState, {
    "Components/Desktop/SetIsOpen": (draft: Draft<DesktopManinNavigationState>, action: { isOpen: boolean }) => {
        draft.isOpen = action.isOpen;
    },
    "Components/DesktopFlyoutDrawer/SetDesktopFlyoutDrawerIsOpen": (
        draft: Draft<DesktopManinNavigationState>,
        action: { isOpen?: boolean },
    ) => {
        draft.flyoutDrawerIsOpen = action.isOpen;
    },
    "Components/DesktopDrawer/SetDesktopNavDrawerIsOpen": (
        draft: Draft<DesktopManinNavigationState>,
        action: { navDrawerIsOpen?: boolean },
    ) => {
        draft.navDrawerIsOpen = action.navDrawerIsOpen;
    },
   
});


(reducers as any).desktopManinNavigationState = desktopManinNavigationReducer;

type DesktopMainNavigationReducer = {
    desktopManinNavigationState: typeof desktopManinNavigationReducer;
};

export type DesktopMainNavigationActions = Parameters<DesktopMainNavigationReducer[keyof DesktopMainNavigationReducer]>[1] | AnyAction;


